import React from 'react';
import {css} from 'emotion';

/* global tw */
export default function partnerHome(props) {

    return (
        <div className={css`${tw`m-8`}`}>
        <h1 className={css`${tw`font-brand`}`}>Hi there!</h1>
        <p className={css`${tw`mt-4 font-normal font-brand text-xl lg:text-xl `}`}>We’re excited to know that you want to partner with us.</p>
        <p className={css`${tw`mt-4 font-normal font-brand text-xl lg:text-xl`}`}>You’ll have to fill necessary details in the form, then you’ll submit it to be reviewed by Zyppys.</p>
        <div className={css`${tw`mt-6 h-12 text-center py-3 font-bold text-white w-1/2 lg:w-1/4 rounded-full cursor-pointer`}; font-family: ‘Plus Jakarta Sans’, ‘Inter’, sans-serif; background: #7C3AED; background-image: linear-gradient(135deg, #7C3AED 0%, #A855F7 100%); box-shadow: 0 4px 14px rgba(124,58,237,0.35); transition: all 0.2s ease; &:hover{ transform: translateY(-1px) scale(1.02); box-shadow: 0 6px 20px rgba(124,58,237,0.45); background-image: linear-gradient(135deg, #6D28D9 0%, #9333EA 100%); } &:active{ transform: scale(0.97); }`}
        onClick={props.optionsClicked}
        >Let’s Go</div>
        </div>
    )
}
